import React from "react";
import '../styles/components/_photolist.scss';

const PhotoList = (props) => {
	return (
		<div>
			<div className="PhotoList p">
				{props.children}
			</div>
		</div>
	);
};

const PhotoListItem = ({children: image, title, year, width}) => (
	<div className="PhotoListItem" style={{width: width + 'px'}}>
		{image}
		<PhotoListItemTitle>
			{title}
		</PhotoListItemTitle>
		<PhotoListItemYear>
			{year}
		</PhotoListItemYear>
	</div>
);

const PhotoListItemTitle = (props) => (
	<div className="PhotoListItemTitle">
		{props.children}
	</div>
);

const PhotoListItemYear = (props) => (
	<div className="PhotoListItemYear">
		{props.children}
	</div>
);

export {PhotoList, PhotoListItem, PhotoListItemTitle, PhotoListItemYear};
